<template>
    <td-dialog :title="title" :before-close="userDialogClose" :visible.sync="dialogUserVisible" width="900px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-tabs v-model="activeName" type="card" style="margin-top:20px;">
            <el-tab-pane :label="$t('userInfo.MESSAGEANDAUTH')" name="first">
                <el-form :model="formUserInfo" ref="formUserInfo" :rules="rules">
                    <input type="password" style="outline:none;border:0;width:0;height:0;float:left;background-color: rgba(0, 0, 0, 0);" />
                    <el-row style="margin-top:2px;" class="iconPassword">
                        <el-col :span="8">
                            <el-form-item :label="$t('common.USERNAME')" :label-width="formLabelWidth" prop="sName">
                                <td-input v-model="formUserInfo.sName" :disabled="isAddData ? false : true" :maxlength="20"></td-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <div v-if="isAddData">
                                <el-form-item :label="$t('common.PASSWORD')" :label-width="formLabelWidth" prop="sNewPassword">
                                    <el-input :placeholder="$t('roleError.ERROR_EMPTY')" v-model="formUserInfo.sNewPassword" :maxlength="50" :clearable="true" show-password></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div v-if="isAddData">
                                <el-form-item :label="$t('common.CONFIRMATION')" :label-width="formLabelWidth" prop="sConfirmPassword">
                                    <el-input :placeholder="$t('roleError.ERROR_EMPTY')" v-model="formUserInfo.sConfirmPassword" :maxlength="50" :clearable="true" show-password></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div v-if="!isAddData">
                                <el-form-item :label="$t('userInfo.USER_LEVEL')" :label-width="formLabelWidth" prop="iLevel">
                                    <td-input-number v-model="formUserInfo.iLevel" :min="1" :max="100"></td-input-number>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div v-if="!isAddData">
                                <el-form-item :label="$t('role.VALIDITY_START')" :label-width="formLabelWidth">
                                    <td-date-time type="date" :placeholder="$t('common.SELECT_DATE')" v-model="formUserInfo.dateTo" :pickerOptions="pickerOptions0" :editable="false"></td-date-time>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="8">
                            <div v-if="isAddData">
                                <el-form-item :label="$t('userInfo.USER_LEVEL')" :label-width="formLabelWidth" prop="iLevel">
                                    <td-input-number v-model="formUserInfo.iLevel" :min="1" :max="100"></td-input-number>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div v-if="isAddData">
                                <el-form-item :label="$t('role.VALIDITY_START')" :label-width="formLabelWidth">
                                    <td-date-time type="date" :placeholder="$t('common.SELECT_DATE')" v-model="formUserInfo.dateTo" :pickerOptions="pickerOptions0" :editable="false"></td-date-time>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="8" v-if="!isAddData">
                            <td-permission :roles="roles">
                                <div slot="havePermission">
                                    <el-form-item>
                                        <td-button :roles="roles" @click="resetDialog()">{{ $t('userInfo.RESET_INFO') }}</td-button>
                                    </el-form-item>
                                </div>
                            </td-permission>
                        </el-col>
                    </el-row>
                    <el-row>
                        <div class="modelSplitBorder"></div>
                    </el-row>
                    <el-row style="padding-top:20px;">
                        <el-row>
                            <el-col :span="1">
                                <div class="userInfoTitle"></div>
                            </el-col>
                            <el-col :span="23">
                                <div style="margin-left:-20px;">{{ $t('userInfo.ORG_AREA') }}</div>
                            </el-col>
                        </el-row>
                        <div style="padding-top:20px;padding-bottom:20px;">
                            <el-row>
                                <el-col :span="11">
                                    <el-form-item :label="$t('userInfo.ORG_AREA')" :label-width="formLabelWidth">
                                        <td-tree-select
                                            v-model="formUserInfo.orgArea"
                                            :inputShow="true"
                                            :multiple="true"
                                            :height="300"
                                            :lazyloading="true"
                                            :draggable="false"
                                            :isDbClick="false"
                                            :isClick="false"
                                            :imgloading="true"
                                            :typeContent="typeContent"
                                            :defaultProps="defaultDeptProps"
                                            ref="TdOrgtree"
                                            :checkNodes="checkedOrgIdList"
                                            :showBox="true"
                                            :sCodes="sCodes"
                                            :checkStrictly="true"
                                            :calInternal="true"
                                            :isDistributed="true"
                                            :interfaceName="orgTreeUrl"
                                            :params="orgParams"
                                            :isPaging="true"
                                            node-key="id"
                                        ></td-tree-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="11" style="padding-left:30px">
                                    <el-form-item :label="$t('userInfo.ORG_GROUP')" :label-width="formLabelWidth">
                                        <td-tree-select
                                            v-model="formUserInfo.orgStructure"
                                            :inputShow="true"
                                            :multiple="true"
                                            :height="300"
                                            :lazyloading="true"
                                            :draggable="false"
                                            :isDbClick="false"
                                            :isClick="false"
                                            :imgloading="true"
                                            :typeContent="typeContent"
                                            :defaultProps="defaultDeptProps"
                                            ref="TdStructuretree"
                                            :checkNodes="checkedOrgStructureIdList"
                                            :showBox="true"
                                            :sCodes="sCodes"
                                            :checkStrictly="true"
                                            :calInternal="true"
                                            :isDistributed="true"
                                            :interfaceName="orgGroupTreeUrl"
                                            :params="structureParams"
                                            :isPaging="true"
                                            node-key="id"
                                        ></td-tree-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </el-row>

                    <el-row v-for="(item, index) in roleInfoList" :key="index">
                        <el-row>
                            <el-col :span="1">
                                <div class="userInfoTitle"></div>
                            </el-col>
                            <el-col :span="23">
                                <div style="margin-left:-20px;">{{ item.sRoleTypeName }}</div>
                            </el-col>
                        </el-row>
                        <div style="padding:20px;">
                            <td-checkbox-group
                                :allList="item.listRoleVo"
                                v-model="item.checkRoleIdList"
                                ref="roleCheckGroup"
                                keys="id"
                                text="roleName"
                                :labelWidth="120"
                                :overLenghOmission="true"
                                checkBoxClass="checkboxstyle"
                            ></td-checkbox-group>
                        </div>
                    </el-row>
                    <dialog-reset-password
                        v-if="dialogResetPasswordVisible"
                        :dialogResetPasswordVisible="dialogResetPasswordVisible"
                        :sysFlg="sysFlg"
                        :editItem="editItem"
                        :title="title"
                        ref="addOrModifyInfo"
                        @userDialogClose="userDialogClose"
                        @submit="submit"
                        @resetPasswordDialogClose="resetPasswordDialogClose"
                    ></dialog-reset-password>
                </el-form>
                <el-row>
                    <div style=" text-align: center;">
                        <td-button type="primary" @click="submitForm()" :loading="loading">{{ $t('common.SAVE') }}</td-button>
                        <td-button type="button" @click="userDialogClose()">{{ $t('common.CANCEL') }}</td-button>
                    </div>
                </el-row>
            </el-tab-pane>
            <el-tab-pane v-if="!isAddData && hasFingerprintProcess" :label="$t('userInfo.FINGERPRINT_COLLECTION')" name="second" class="fingerPane" style="margin-top:-20px;">
                <finger-data-collection :userId="editItem.userId" :showClose="true" @fingerintClose="userDialogClose()" style="padding-top:20px;"></finger-data-collection>
            </el-tab-pane>
            <!-- 白名单 -->
            <el-tab-pane :label="$t('userInfo.LOGINSETTING')" name="whiteList" style="margin-top:-20px;">
                <whiteList-pane
                    v-if="!isAddData"
                    ref="whiteListPane"
                    :ipList="ipList"
                    :macList="macList"
                    :timeList="timeList"
                    :isAddData="isAddData"
                    @whiteListSave="whiteListSave"
                    @whiteListClose="userDialogClose"
                ></whiteList-pane>
                <whiteList-pane v-else ref="whiteListPane" :isAddData="isAddData" @whiteListSave="whiteListSave" @whiteListClose="userDialogClose"></whiteList-pane>
            </el-tab-pane>
            <!-- 根据扩展信息自动创建tab -->
            <el-tab-pane v-for="item in formUserInfo.userExtends" :key="item.sModuleId" :label="item.sModuleName" :name="item.sModuleName" style="margin-top:-20px;">
                <personalInfo-pane
                    :extendList="item.extendList"
                    :sysFlg="sysFlg"
                    :editItem="editItem"
                    :isAddData="isAddData"
                    :moduleId="item.sModuleId"
                    :ref="'personPane_' + item.sModuleId"
                    :loading="personInfoloading"
                    @submitForm="submitForm"
                    @personalInfoClose="userDialogClose"
                ></personalInfo-pane>
            </el-tab-pane>
        </el-tabs>
        <span slot="footer"></span>
    </td-dialog>
</template>
<script>
import dialogResetPassword from './dialogResetPassword.vue';
import resourceApi from '../assets/api.js';
import logonProcessApi from '../../loginProcess/assets/api.js';
import whiteList from './whiteList.vue';
import personalInfoPane from './personalInfo.vue';
export default {
    props: ['title', 'dialogUserVisible', 'editItem', 'isAddData', 'sysFlg', 'sysList', 'roleInfoList'],
    components: {
        'dialog-reset-password': dialogResetPassword,
        'personalInfo-pane': personalInfoPane,
        'whiteList-pane': whiteList
    },
    created() {
        this.getMenuUrl();
        this.initRegex();
        let data = [];
        let param = {
            sysID: this.sysFlg,
            orgFlg: 0
        };
        resourceApi.getRoleInfo(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getRoleInfo', response.data.statusMessage);
                return;
            }
            data = response.data.content;
            this.sysRoles = data;
        });
        let doorListparam = {
            sysID: this.sysFlg,
            orgFlg: 2
        };
        resourceApi.getUserExtends({ sysFlg: this.sysFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('user/getUserExtends', response.data.statusMessage);
                return;
            }
            data = response.data.content;
            this.formUserInfo.userExtends = data;
            if (!this.isAddData) {
                // 为编辑状态则进行初始化数据
                this.initEditData();
            }
        });
        //初始化指纹信息
        logonProcessApi.listLoginProcessByCondition({ systemId: window.app.sPlatformFlg }, response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('loginProcess/listLoginProcess', response.data.statusMessage);
            }
            let listProcess = response.data.content;
            if (window.vue.$util.isEmpty(listProcess)) {
                return;
            }
            listProcess.forEach(elem => {
                if (elem.sCheckType == 'fingerprint') {
                    this.hasFingerprintProcess = true;
                }
            });
        });
    },
    // 定义变量
    data() {
        let validatePassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                if (this.formUserInfo.sConfirmPassword !== '') {
                    this.$refs.formUserInfo.validateField('sConfirmPassword');
                }
                callback();
            }
        };
        let validateConfirmPassword = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else if (this.formUserInfo.sNewPassword !== value) {
                callback(this.$t('error.ERROR_PASSWORD_NOT_EQUAl'));
            } else {
                callback();
            }
        };
        let validateUserName = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.formUserInfo.sId;
            }
            let param = {
                sName: value,
                sysFlg: this.sysFlg,
                sId: sId
            };
            resourceApi.getUserInfoByName(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserInfoByName', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('error.ERROR_USER_CAPTION_REPEAT'));
                } else {
                    callback();
                }
            });
        };
        return {
            hasFingerprintProcess: false,
            defaultDeptProps: {
                parentId: 'parentId',
                children: 'children',
                id: 'id',
                label: 'caption',
                imgName: 'sIcon'
            },
            sCodes: ['BH-0001'],
            orgTreeUrl: { query: '', search: '' },
            orgParams: {
                rootCodes: ['BH-0001'],
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            structureParams: {
                currentPage: 1,
                needPage: true,
                pageSize: 50
            },
            activeName: 'first',
            pg: window.pgCommon,
            // User表单信息
            formUserInfo: {
                sId: '',
                sName: '',
                iLevel: '9',
                doorRole: [],
                dateTo: '2099-01-01',
                sConfirmPassword: '',
                sNewPassword: '',
                userExtends: [],
                orgArea: '',
                orgStructure: ''
            },
            groups: {
                label: 'name',
                children: 'zones'
            },
            orgList: [],
            roles: ['admin'],
            doorRoleList: [],
            dialogResetPasswordVisible: false,
            //组织架构参数 -- start --
            titleOrgGroup: this.$t('userInfo.SELECT_ORG_GROUP'),
            orgGroupTreeUrl: { query: '', search: '' },
            checkedOrgGroupList: '',
            //组织架构参数 -- end --
            ipList: [],
            macList: [],
            timeList: [],
            formIpWhiteList: {
                ipList: []
            },
            formMacWhiteList: {
                macList: []
            },
            formTimeWhiteList: {
                timeList: []
            },
            userExtends: [],
            count: 1,
            checkedOrgIdList: [],
            checkedOrgStructureIdList: [],
            sysRoles: [],
            checkedUser: [1, 4],
            loading: false,
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            formLabelWidth: '30%',
            passwordRule: '',
            ruleMessage: '',
            numRreg: new RegExp('^([a-zA-Z0-9_]){32}$'),
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' },
                    {
                        pattern: this.$regex.USERCAPTION_RULE,
                        message: this.$t('error.ERROR_USER_CAPTION_ILLEGAL')
                    },
                    { validator: validateUserName, trigger: 'blur' }
                ],
                sNewPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validatePassword, trigger: 'blur' }
                ],
                sConfirmPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 50, message: this.$t('error.ERROR_CAPTION_MAX_LENGTH'), trigger: 'blur' },
                    { validator: validateConfirmPassword, trigger: 'blur' }
                ],
                iLevel: [{ required: true, message: this.$t('userInfo.ERROR_USER_LEVEL_ILLEGAL'), trigger: 'blur' }]
            },
            extendIds: [],
            extendVals: [],
            personInfoloading: false,
            moduleId: '',
            timeWhiteList: []
        };
    },
    // 定义并实现方法体
    methods: {
        getTree(orgIdList) {
            if (orgIdList.length == 0) {
                return;
            }
            resourceApi.orgFind(JSON.stringify({ orgIdList: orgIdList }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/OrgManagerController/find', response.data.statusMessage);
                    return;
                }
                this.checkedOrgIdList.length = 0;
                if (response.data && response.data.content && response.data.content[0]) {
                    response.data.content[0].data.forEach(data => {
                        let param = {
                            id: data.id,
                            caption: data.caption
                        };
                        this.checkedOrgIdList.push(param);
                    });
                }
                this.formUserInfo.orgArea = this.checkedOrgIdList;
            });

            resourceApi.orgStructureFind(JSON.stringify({ orgIdList: orgIdList }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/OrgStructureController/findOrgStructure', response.data.statusMessage);
                    return;
                }
                this.checkedOrgStructureIdList.length = 0;
                if (response.data && response.data.content) {
                    response.data.content.forEach(data => {
                        let param = {
                            id: data.sOrgId,
                            caption: data.sName
                        };
                        this.checkedOrgStructureIdList.push(param);
                    });
                }
                this.formUserInfo.orgStructure = this.checkedOrgStructureIdList;
            });
        },
        initRegex() {
            let params = {
                sTag: 'PASSWORD_RULE'
            };
            window.vue.$api.getDictValuesByType(JSON.stringify(params), response => {
                this.passwordRule = response.data.content[0].sCode;
                this.ruleMessage = response.data.content[0].sValue;
                let regx = {
                    pattern: this.passwordRule,
                    message: this.ruleMessage
                };
                this.rules.sNewPassword.push(regx);
            });
        },
        getMenuUrl() {
            let arr = this.sysList;
            for (let index in arr) {
                if (arr[index].sSysFlg === this.sysFlg) {
                    this.menuUrl = arr[index].sMenuUrl;
                    this.hostUrl = arr[index].sUrl;
                    this.deptUrl = arr[index].sDeptUrl;
                    this.orgTreeUrl.query = this.hostUrl + this.deptUrl;
                    this.orgTreeUrl.search = this.hostUrl + '/OrgManagerController/find';
                    this.orgGroupTreeUrl.query = this.hostUrl + '/OrgStructureController/findOrgStructureTree';
                    this.orgGroupTreeUrl.search = this.hostUrl + '/OrgStructureController/findOrgStructureTree';
                }
            }
        },
        validateExtendName: function(rule, value, callback) {
            for (let j = 0; j < this.formUserInfo.userExtends.length; j++) {
                for (let i = 0; i < this.formUserInfo.userExtends[j].extendList.length; i++) {
                    const element = this.formUserInfo.userExtends[j].extendList[i];
                    if (element.sId === rule.field) {
                        if (element.optionValue === '' || element.optionValue == null || element.optionValue === undefined) {
                            if (element.isCheckNull === 1) {
                                const message = this.$t('common.PLEASE_INPUT') + element.sName;
                                callback(message);
                                break;
                            }
                        } else {
                            this.checkIllegal(element, callback);
                        }
                        callback();
                        break;
                    }
                }
            }
            callback();
        },
        // 动态控件非法正则验证
        checkIllegal(item, callback) {
            if (item.sExtendType === 'input') {
                let reg = new RegExp(this.$regex.INPUT_RULE);
                if (!reg.test(item.optionValue)) {
                    callback(this.$t('error.ERROR_INPUT_ILLEGAL'));
                    return;
                }
            }

            callback();
        },
        // 初始化编辑数据
        initEditData() {
            this.formUserInfo.sName = this.editItem.userName;
            this.formUserInfo.dateTo = this.formatDate(new Date(this.editItem.dtLimit * 1), 'yyyy-MM-dd');
            this.formUserInfo.sId = this.editItem.userId;
            this.formUserInfo.iLevel = this.editItem.iLevel;

            resourceApi.getUserIpList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserIpList', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;

                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    this.ipList.push(element.sIp.replace(/-/g, '至'));
                }
            });
            resourceApi.getUserMacList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserMacList', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    this.macList.push(element.sMac);
                }
            });
            resourceApi.getUserTimeList(JSON.stringify({ sId: this.formUserInfo.sId }), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserMacList', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    this.timeList.push(element.sStartTime + ' 至 ' + element.sEndTime);
                }
            });
            let param = {
                sId: this.formUserInfo.sId,
                sysFlg: this.sysFlg,
                orgFlg: 1
            };
            resourceApi.getUserRoleInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('user/getUserRoleInfo', response.data.statusMessage);
                    return;
                }
                let array = response.data.content;
                let orgIdList = [];
                array.forEach(content => {
                    if (content.sId) {
                        orgIdList.push(content.sId);
                    }
                });
                this.getTree(orgIdList);
            });
        },
        //获取角色ID
        getCheckdRole() {
            let checkGroup = this.$refs.roleCheckGroup;
            let checkRoleGroup = [];
            for (let index = 0; index < checkGroup.length; index++) {
                const element = checkGroup[index];
                checkRoleGroup.push(...element.getCheckList());
            }
            return checkRoleGroup.join(',');
        },
        // 提交数据
        submitForm(moduleId) {
            //如果点击的是扩展tab页的保存按钮，需要控制按钮loading
            this.moduleId = moduleId;
            //校验拓展tab页
            this.extendIds.length = 0;
            this.extendVals.length = 0;
            let tipList = [];
            //编辑过后将用户等级保存到缓存中
            sessionStorage.setItem('userLevel', this.formUserInfo.iLevel);
            this.formUserInfo.userExtends.forEach(element => {
                let extendInfo = this.$refs['personPane_' + element.sModuleId][0].getFormData();
                if (!this.$util.isEmpty(extendInfo) && !extendInfo.isError) {
                    extendInfo.extendIds.forEach(extend => {
                        this.extendIds.push(extend);
                    });
                    extendInfo.extendVals.forEach(extend => {
                        this.extendVals.push(extend);
                    });
                } else if (!this.$util.isEmpty(extendInfo) && extendInfo.isError) {
                    tipList.push(element.sModuleName);
                }
            });
            if (this.$util.isArray(tipList) && tipList.length > 0) {
                let tips = '';
                let i = 0;
                tipList.forEach(tip => {
                    if (i == 0) {
                        tips = tip;
                    } else {
                        tips = tips + '、' + tip;
                    }
                    i++;
                });
                tips = this.$t('userInfo.PLEASE_CHECK') + '【' + tips + '】' + this.$t('userInfo.INVALID_CONTENT');
                this.$message({ showClose: true, message: tips, type: 'warning' });
                this.extendIds.length = 0;
                this.extendVals.length = 0;
                return;
            }
            //校验白名单按钮是否确认
            if (this.formIpWhiteList.ipList.length > 0 || this.formMacWhiteList.macList.length > 0 || this.formTimeWhiteList.timeList.length > 0) {
                this.$message({ showClose: true, message: this.$t('userInfo.PLEASE_CONFIRM_WHITE_LIST'), type: 'warning' });
                return;
            }
            //校验拓展tab页end
            // 校验白名单页start
            if (!this.$refs.whiteListPane.getFormValid()) {
                this.$message({ showClose: true, message: this.$t('userInfo.PLEASE_CHECK_WHITE_LIST'), type: 'warning' });
                return;
            }
            // 校验白名单页end
            this.$refs['formUserInfo'].validate(valid => {
                if (valid) {
                    if (!this.$util.isEmpty(this.moduleId)) {
                        this.personInfoloading = true;
                    } else {
                        this.loading = true;
                    }
                    if (this.formUserInfo.sNewPassword !== this.formUserInfo.sConfirmPassword) {
                        this.$message({ showClose: true, message: this.$t('error.ERROR_PASSWORD_NOT_EQUAl'), type: 'error' });
                        if (!this.$util.isEmpty(this.moduleId)) {
                            this.personInfoloading = false;
                        } else {
                            this.loading = false;
                        }
                        return;
                    }
                    let checkGroup = this.getCheckdRole();
                    if (this.formUserInfo.doorRole.length > 0) {
                        let doorRoleId = this.formUserInfo.doorRole;
                        let tempStr = '';
                        doorRoleId.forEach(id => {
                            if (tempStr != '') {
                                tempStr += ',' + id;
                            } else {
                                tempStr += id;
                            }
                        });
                        if (checkGroup !== '') {
                            checkGroup += ',' + tempStr;
                        } else {
                            checkGroup = tempStr;
                        }
                    }
                    let ipListStr = '';
                    if (this.ipList.length > 0) {
                        ipListStr = this.ipList.join('#');
                        ipListStr = ipListStr.replace(/至/g, '-');
                    }
                    let macListStr = '';
                    if (this.macList.length > 0) {
                        macListStr = this.macList.join('#');
                    }
                    let timeListStr = '';
                    if (this.timeList.length > 0) {
                        this.timeWhiteList = [];
                        this.timeList.forEach(time => {
                            this.timeWhiteList.push(time.replace(/至/g, '#'));
                        });
                    }
                    let checkOrg = '';
                    let list = this.getCheckedOrgList();
                    checkOrg = list.join(',');
                    let content = {
                        sId: this.formUserInfo.sId,
                        sName: this.formUserInfo.sName,
                        oldPassword: this.formUserInfo.sPassword,
                        newPassword: '',
                        sConfirmPassword: '',
                        dateTo: this.formUserInfo.dateTo + ' 23:59:59',
                        iLevel: this.formUserInfo.iLevel,
                        ipList: ipListStr,
                        macList: macListStr,
                        timeIntervalList: this.timeWhiteList,
                        sysFlg: this.sysFlg,
                        roleList: checkGroup,
                        extendIds: this.extendIds.join(','),
                        extendValues: this.extendVals.join(','),
                        orgIds: checkOrg
                    };
                    if (!this.$util.isEmpty(this.formUserInfo.sNewPassword)) {
                        content.newPassword =
                            sessionStorage.getItem('encryptionFlg') == window.vue.$common.encryption
                                ? window.vue.$util.publicKeyEncrypt(this.formUserInfo.sNewPassword)
                                : this.formUserInfo.sNewPassword;
                    }
                    resourceApi.validateResConflict(JSON.stringify(content), response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('user/validateResConflict', response.data.statusMessage);
                            return;
                        }
                        let count = response.data.count;
                        if (count > 0) {
                            this.$confirm(this.$t('role.RES_CONFLICT_TIPS'), this.$t('common.TIPS'), {
                                confirmButtonText: this.$t('common.SURE'),
                                cancelButtonText: this.$t('common.CANCEL'),
                                type: 'warning'
                            })
                                .then(() => {
                                    this.saveUserInfo(content);
                                })
                                .catch(() => {
                                    // this.$message.info(this.$t('common.ADD_FAIL'))
                                    this.$log.error('user/validateResConflict---- Fail');
                                });
                        } else {
                            this.saveUserInfo(content);
                        }
                    });
                } else {
                    this.$message({ showClose: true, message: this.$t('userInfo.PLEASE_CHECK_INFO_AUTH'), type: 'warning' });
                }
            });
        },
        saveUserInfo(content) {
            if (this.isAddData) {
                resourceApi.insertUserInfo(JSON.stringify(content), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('user/insertUserInfo', response.data.statusMessage);
                        if (!this.$util.isEmpty(this.moduleId)) {
                            this.personInfoloading = false;
                        } else {
                            this.loading = false;
                        }
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                    this.userDialogClose();
                    this.$emit('submit');
                });
            } else {
                resourceApi.updateUserInfo(JSON.stringify(content), response => {
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('user/updateUserInfo', response.data.statusMessage);
                        if (!this.$util.isEmpty(this.moduleId)) {
                            this.personInfoloading = false;
                        } else {
                            this.loading = false;
                        }
                        return;
                    }
                    this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                    this.userDialogClose();
                    this.$emit('submit');
                });
            }
        },
        submit() {
            this.$emit('submit');
        },
        // 关闭窗口之前需要调用的方法
        userDialogClose() {
            this.$emit('userDialogClose');
            this.$refs['formUserInfo'].resetFields(); // 重置表单数据
        },
        getSelection() {
            let temp = [];
            let idTemp = [];
            let extendVals = [];
            let extendIds = [];
            this.formUserInfo.userExtends.forEach(v => {
                idTemp.push(v.sModuleId);
                temp.push(v.sModuleName);
                v.extendList.forEach(val => {
                    extendIds.push(val.sId);

                    if (Array.isArray(val.optionValue)) {
                        extendVals.push(val.optionValue.join('|'));
                    } else {
                        extendVals.push(val.optionValue);
                    }
                });
            });
            //
            return temp;
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        resetDialog() {
            this.dialogResetPasswordVisible = true;
        },
        resetPasswordDialogClose() {
            this.dialogResetPasswordVisible = false;
        },
        getCheckedOrgList(data) {
            let ids = [];
            if (this.formUserInfo.orgArea) {
                this.formUserInfo.orgArea.forEach(area => {
                    ids.push(area.id);
                });
            }
            if (this.formUserInfo.orgStructure) {
                this.formUserInfo.orgStructure.forEach(structure => {
                    ids.push(structure.id);
                });
            }
            return ids;
        },
        formatDate(date, fmt) {
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ('00' + str).substr(str.length));
                }
            }
            return fmt;
        },
        whiteListSave(ipList, macList, timeList, formIpWhiteList, formMacWhiteList, formTimeWhiteList) {
            this.ipList = ipList;
            this.macList = macList;
            this.timeList = timeList;
            this.formIpWhiteList = formIpWhiteList;
            this.formMacWhiteList = formMacWhiteList;
            this.formTimeWhiteList = formTimeWhiteList;
            this.submitForm();
        }
    }
};
</script>
<style scoped>
.checkboxstyle {
    width: 165px;
    margin: 5px !important;
}
.fingerPane >>> .finger_main {
    margin: 0px 0px;
}
.fingerPane >>> .fingerprint_collection_div {
    margin-left: 0px;
}
input::-ms-reveal {
    display: none;
}
</style>
